// Display translations only: persisted identifiers, product records and user names stay intact.
const translations: Record<string, string> = Object.fromEntries(`All|Wszystkie
Favorites|Ulubione
Bathroom|Łazienka
Bedroom|Sypialnia
Decor|Dekoracje
Dining|Jadalnia
Kitchen|Kuchnia
Lighting|Oświetlenie
Living|Salon
Office|Biuro
Rugs|Dywany
Storage|Przechowywanie
Utility|Pomieszczenia gospodarcze
Garage|Garaż
floor|Podłoga
ceiling|Sufit
door|Drzwi
window|Okno
pending|Oczekuje
accepted|Zatwierdzono
rejected|Odrzucono
Natural oak boards|Deski z naturalnego dębu
Warm white|Ciepła biel
Chalk|Kredowy
Soft sage|Jasna szałwia
Clay|Glina
Charcoal|Grafit
Pale wood|Jasne drewno
Warm wood|Ciepłe drewno
Dark wood|Ciemne drewno
Concrete|Beton
Ceramic tile|Płytki ceramiczne
Linen|Len
Woven jute|Pleciona juta
Sand stone tile|Płytki piaskowe
2 × 2 shelving|Regał 2 × 2
2-drawer bedside chest|Szafka nocna z 2 szufladami
3-seat chaise sofa|Sofa 3-osobowa z szezlongiem
3-seat sofa|Sofa 3-osobowa
4-drawer chest|Komoda z 4 szufladami
5-drawer unit|Szafka z 5 szufladami
Base cabinet frame|Korpus szafki stojącej
Bed frame 160 × 200|Rama łóżka 160 × 200
Bed frame with drawers|Rama łóżka z szufladami
Bed frame · 160 × 200 mattress|Rama łóżka · materac 160 × 200
Bentwood armchair|Fotel z giętego drewna
Bookcase|Regał na książki
Bookcase with doors and top unit|Regał z drzwiami i nadstawką
Bookcase with glass/panel doors|Regał z drzwiami szklanymi/panelowymi
Bookcase with top unit|Regał z nadstawką
Children’s table|Stolik dziecięcy
Coffee table|Stolik kawowy
Corner sleeper sofa|Narożnik rozkładany
Counter stool · 63 cm seat|Hoker · siedzisko 63 cm
Daybed with 3 drawers|Łóżko dzienne z 3 szufladami
Desk|Biurko
Desk 140 × 60|Biurko 140 × 60
Dining chair|Krzesło do jadalni
Dining table|Stół do jadalni
Extendable table, closed|Stół rozkładany, złożony
Flatwoven rug|Dywan tkany na płasko
Floor lamp|Lampa podłogowa
Gateleg table, one leaf open|Stół składany, jedno skrzydło otwarte
Glass-door cabinet|Witryna
Globe table lamp|Lampa stołowa kula
Kitchen island|Wyspa kuchenna
Kitchen trolley|Wózek kuchenny
Low-pile rug|Dywan z krótkim włosiem
Office chair|Krzesło biurowe
Office chair with armrests|Krzesło biurowe z podłokietnikami
Open pine shelving|Otwarty regał sosnowy
Pendant lamp|Lampa wisząca
Reading floor lamp|Lampa podłogowa do czytania
Reversible bed, loft position|Łóżko odwracane, pozycja podwyższona
Round glass coffee table|Okrągły szklany stolik kawowy
Round mirror, 80 cm|Okrągłe lustro, 80 cm
Shelving, 4 × 4|Regał 4 × 4
Shoe cabinet, one unit|Szafka na buty, jeden moduł
Sofa with chaise|Sofa z szezlongiem
Stepped storage with boxes|Schodkowy regał z pojemnikami
Swivel armchair|Fotel obrotowy
TV bench with doors|Szafka RTV z drzwiami
Tall appliance cabinet, 200 cm|Słupek na AGD, 200 cm
Tall appliance cabinet, 220 cm|Słupek na AGD, 220 cm
Tall bathroom cabinet|Wysoka szafka łazienkowa
Tall shelving with 2 storage boxes|Wysoki regał z 2 pojemnikami
Upholstered dining chair|Tapicerowane krzesło do jadalni
Vanity with countertop basin|Szafka z umywalką nablatową
Wall cabinet frame|Korpus szafki wiszącej
Wall cabinet, 100 cm|Szafka wisząca, 100 cm
Wardrobe|Szafa
Wardrobe with top units, 6 doors|Szafa z nadstawkami, 6 drzwi
Wardrobe, 100 cm wide, tall|Wysoka szafa, szerokość 100 cm
Wardrobe, 200 cm wide, standard|Standardowa szafa, szerokość 200 cm
Wardrobe, 200 cm wide, tall|Wysoka szafa, szerokość 200 cm
Wardrobe, 3 doors|Szafa 3-drzwiowa
Washbasin frame|Stelaż pod umywalkę
Wing chair|Fotel uszak
Oak platform bed|Dębowe łóżko platformowe
Floating oak bedside drawer|Wisząca dębowa szafka nocna
Cream wool rug|Kremowy dywan wełniany
Brass dome reading lamp|Mosiężna lampa do czytania
Round oak pedestal table|Okrągły stolik dębowy
Rounded cream lounge chair|Zaokrąglony kremowy fotel
Corner sofa|Narożnik
TV & media unit|Szafka RTV
Bar stool|Hoker
Linen sofa|Lniana sofa
Lounge chair|Fotel wypoczynkowy
Dining table & chairs|Stół i krzesła
Double bed|Łóżko podwójne
Thermal buffer tank · 1500 l planning envelope|Bufor ciepła · obrys orientacyjny 1500 l
Writing desk|Biurko
Kitchen cabinet|Szafka kuchenna
Refrigerator|Lodówka
Cooker & oven|Kuchenka z piekarnikiem
Kitchen sink|Zlewozmywak
Freestanding bath|Wanna wolnostojąca
Compact freestanding bath|Mała wanna wolnostojąca
Shallow bathroom wall cabinet|Płytka wisząca szafka łazienkowa
Walk-in shower|Otwarta kabina prysznicowa
Toilet|Toaleta
Bathroom vanity|Szafka pod umywalkę
Washing machine|Pralka
Family car|Samochód rodzinny
Ash|Jesion
Ash veneer|Fornir jesionowy
Birch veneer / Knisa light beige|Fornir brzozowy / Knisa jasnobeżowy
Black|Czarny
Black / oak|Czarny / dąb
Dark grey|Ciemnoszary
Djuparp green-blue|Djuparp zielononiebieski
Faringe light grey|Faringe jasnoszary
Glose black|Glose czarny
Grey|Szary
Gunnared medium grey|Gunnared szary
High-gloss white|Biały połysk
Kelinge beige|Kelinge beżowy
Knäbäck anthracite|Knäbäck antracytowy
Natural jute|Naturalna juta
Nordvalla dark grey|Nordvalla ciemnoszary
Oak veneer|Fornir dębowy
Oak veneer / glass|Fornir dębowy / szkło
Pale pink|Jasnoróżowy
Pine|Sosna
Tresund light beige|Tresund jasnobeżowy
Vissle light grey|Vissle jasnoszary
White|Biały
White / Lappviken white|Biały / Lappviken biały
White / pine|Biały / sosna
White / white|Biały / biały
White glass|Białe szkło
White metal / glass|Biały metal / szkło
White-stained pine / white / multicolour|Bielona sosna / biały / wielokolorowy
176 × 209 cm is the frame footprint. Mattress and bedding are shown for context and sold separately.|Obrys ramy: 176 × 209 cm. Materac i pościel pokazano poglądowo; są sprzedawane osobno.
Shown at maximum overall height; seat height is adjustable.|Pokazano maksymalną wysokość; siedzisko ma regulację wysokości.
Open cabinet carcass: 60 cm depth with rail (59 cm without rail). Fronts, legs and worktop excluded.|Otwarty korpus: głębokość 60 cm z szyną (59 cm bez). Bez frontów, nóg i blatu.
Open cabinet carcass with suspension-rail depth 37.6 cm (36.6 cm without rail); doors and fittings excluded.|Otwarty korpus: głębokość 37,6 cm z szyną (36,6 cm bez). Bez drzwi i wyposażenia.
Open metal washbasin frame only; washbasin, mixer, waste trap and optional legs are separate.|Sam metalowy stelaż; umywalka, bateria, syfon i opcjonalne nogi są osobno.
Shown closed; sleeping surface 140 × 204 cm when unfolded.|Pokazano w stanie złożonym; po rozłożeniu powierzchnia spania 140 × 204 cm.
170 × 209 cm is the frame, for a 160 × 200 cm mattress. Bedding shown for context.|Rama 170 × 209 cm, do materaca 160 × 200 cm. Pościel pokazana poglądowo.
Frame only, 166 × 206 × 47 cm; mattress 160 × 200 cm. Separate headboard excluded.|Sama rama 166 × 206 × 47 cm; materac 160 × 200 cm. Bez osobnego zagłówka.
Shown closed, 209 cm along the drawer front; mattress 80 × 200 cm.|Pokazano złożone, 209 cm wzdłuż frontu szuflad; materac 80 × 200 cm.
Shown at 130 cm; extends to 190 cm.|Pokazano długość 130 cm; po rozłożeniu 190 cm.
One leaf raised: 89 cm; folded 26 cm, both leaves raised 152 cm.|Jedno skrzydło otwarte: 89 cm; po złożeniu 26 cm, oba otwarte 152 cm.
Published assembled size includes feet. Handles sold separately.|Wymiary po złożeniu obejmują nóżki. Uchwyty sprzedawane osobno.
One 52 × 18 × 39 cm unit; IKEA sells this article as a pack of two.|Jeden moduł 52 × 18 × 39 cm; IKEA sprzedaje ten produkt w zestawie 2 sztuk.
Shown at 75 cm; assembly height adjustable from 65 to 85 cm.|Pokazano wysokość 75 cm; regulacja przy montażu od 65 do 85 cm.
Shown at maximum height; seat adjusts from 45 to 56 cm.|Pokazano maksymalną wysokość; regulacja siedziska od 45 do 56 cm.
Carcass only. Depth includes suspension rail; fronts, legs and appliances excluded.|Sam korpus. Głębokość obejmuje szynę; bez frontów, nóg i urządzeń.
Two 60 cm cabinets, 122 cm countertop and one basin. Tap and handles excluded; mount to wall.|Dwie szafki 60 cm, blat 122 cm i jedna umywalka. Bez baterii i uchwytów; montaż do ściany.
Frame for a 90 × 200 cm mattress, shown in loft position.|Rama do materaca 90 × 200 cm, pokazana w pozycji podwyższonej.
Table with removable top panels. Storage boxes sold separately.|Stół ze zdejmowanymi panelami blatu. Pojemniki sprzedawane osobno.
50 cm diameter × 46 cm shade; adjustable 180 cm cable excluded from shade dimensions.|Klosz o średnicy 50 cm i wysokości 46 cm; regulowany przewód 180 cm nie jest wliczony.
IKEA: height 181 cm, base Ø34 cm, shade Ø31.5 cm. Overall width is unpublished; 50 cm planning allowance.|IKEA: wysokość 181 cm, podstawa Ø34 cm, klosz Ø31,5 cm. Brak szerokości całkowitej; orientacyjnie przyjęto 50 cm.
IKEA: diameter 80 cm. Depth is unpublished; model uses a 2 cm planning thickness.|IKEA: średnica 80 cm. Brak podanej głębokości; w modelu przyjęto 2 cm.
Total thickness 18 mm; pile 15 mm.|Grubość całkowita 18 mm; włosie 15 mm.
Actual height 146.5 cm; nominal product size 147 × 147 cm.|Rzeczywista wysokość 146,5 cm; nominalny rozmiar 147 × 147 cm.
Four hinged doors. Upright assembly requires at least 237 cm ceiling height.|Czworo drzwi na zawiasach. Montaż pionowy wymaga sufitu na wysokości co najmniej 237 cm.
Three 180 cm frames with 60 cm top units and feet. Handles sold separately.|Trzy korpusy 180 cm z nadstawkami 60 cm i nóżkami. Uchwyty sprzedawane osobno.
202 cm bookcase plus 35 cm height extension.|Regał 202 cm i nadstawka 35 cm.
Upright assembly requires at least 237 cm ceiling height.|Montaż pionowy wymaga sufitu na wysokości co najmniej 237 cm.
Four hinged doors. Upright assembly requires at least 202 cm ceiling height.|Czworo drzwi na zawiasach. Montaż pionowy wymaga sufitu na wysokości co najmniej 202 cm.
Tall 226.4 cm configuration includes two pine storage boxes.|Wysoka konfiguracja 226,4 cm obejmuje dwa sosnowe pojemniki.
Carcass only. Depth includes suspension rail; fronts and interior fittings excluded.|Sam korpus. Głębokość obejmuje szynę; bez frontów i wyposażenia wewnętrznego.
Polish product listing may redirect; reference configuration retained, no stock claim.|Polska strona produktu może przekierowywać; zachowano konfigurację referencyjną, bez potwierdzenia dostępności.
Archived Polish article; current Polish URL redirects to the series.|Archiwalny polski produkt; obecny adres przekierowuje do serii.`.split('\n').map(line => line.split('|')))

export const interiorText = (text: string) => translations[text] ?? text

const errors: Record<string, string> = Object.fromEntries(`Enter finite wall coordinates.|Podaj prawidłowe współrzędne ściany.
Keep partitions clear of floor openings.|Ściana nie może przecinać otworów w stropie.
This edit would collapse a connected wall.|Ta zmiana spowodowałaby zanik połączonej ściany.
An opening would no longer fit its wall.|Otwór nie zmieści się w ścianie po tej zmianie.
This edit would cross or collapse a room boundary.|Ta zmiana spowodowałaby przecięcie lub zanik granicy pomieszczenia.
The room boundary must remain connected.|Granica pomieszczenia musi pozostać zamknięta.
A partition cannot split a locked wall or room.|Ściana nie może dzielić zablokowanej ściany lub pomieszczenia.
Place the partition away from doors and windows.|Umieść ścianę z dala od drzwi i okien.
Select an unlocked room to divide.|Wybierz odblokowane pomieszczenie do podziału.
Partition references must be unique.|Nie udało się nadać ścianie unikalnego identyfikatora. Spróbuj ponownie.
Enter a room name and a wall thickness between 0.06 and 0.5 m.|Podaj nazwę pomieszczenia i grubość ściany od 0,06 do 0,5 m.
Start and end the partition on the selected room boundary.|Wskaż początek i koniec na ścianach wybranego pomieszczenia.
Draw a partition through the room interior.|Poprowadź ścianę przez wnętrze pomieszczenia.
A partition cannot cross another room boundary.|Ściana nie może przecinać granicy innego pomieszczenia.
Keep the partition clear of stair and floor openings.|Ściana nie może przecinać schodów ani otworów w stropie.
Could not connect the partition endpoints.|Nie udało się połączyć końców ściany. Wskaż je ponownie na granicy pomieszczenia.
Select an unlocked partition between two rooms.|Wybierz odblokowaną ścianę działową między dwoma pomieszczeniami.
Remove the partition’s openings before merging rooms.|Usuń otwory w ścianie przed połączeniem pomieszczeń.
These rooms cannot be merged along a single partition.|Tych pomieszczeń nie można połączyć przez usunięcie jednej ściany.
The exterior envelope stays fixed. Select an unlocked interior wall.|Obrys zewnętrzny jest stały. Wybierz odblokowaną ścianę działową.
Wall thickness must be between 0.06 and 0.5 m.|Grubość ściany musi wynosić od 0,06 do 0,5 m.
Keep wall height within the storey.|Wysokość ściany nie może przekraczać wysokości kondygnacji.
This move cannot keep the connected walls at right angles.|Przy tym przesunięciu nie można zachować kątów prostych połączonych ścian.
A connected wall or room is locked.|Połączona ściana lub pomieszczenie jest zablokowane.
This edit would move the exterior envelope.|Ta zmiana przesunęłaby obrys zewnętrzny budynku.
This edit would overlap a room boundary.|Ta zmiana spowodowałaby nałożenie się granic pomieszczeń.
Could not reconnect the sliding wall junctions.|Nie udało się odtworzyć połączeń przesuwanej ściany.
Select unlocked interior walls on this floor. The exterior envelope stays fixed.|Wybierz odblokowane ściany działowe na tej kondygnacji. Obrys zewnętrzny jest stały.
A selected room is locked.|Wybrane pomieszczenie jest zablokowane.
Select at least two walls to group.|Wybierz co najmniej dwie ściany do grupowania.
Enter a finite movement.|Podaj prawidłową odległość przesunięcia.
This floor no longer exists.|Ta kondygnacja już nie istnieje.
Select furniture on this floor.|Wybierz mebel na tej kondygnacji.
Select an unlocked room.|Wybierz odblokowane pomieszczenie.
Select an unlocked wall.|Wybierz odblokowaną ścianę.
Opening not found.|Nie znaleziono otworu.
Enter valid opening dimensions.|Podaj prawidłowe wymiary otworu.
The opening must fit inside its wall.|Otwór musi mieścić się w ścianie.
The opening belongs to another wall.|Otwór należy do innej ściany.
Leave space between openings.|Zachowaj odstęp między otworami.
Furniture must belong to the selected floor.|Mebel musi należeć do wybranej kondygnacji.
This item is taller than the room at its chosen elevation.|Obiekt na wybranej wysokości nie mieści się pod sufitem.
Choose a supported IKEA product and variant.|Wybierz obsługiwany produkt i wariant IKEA.
IKEA products keep their supported finish. Choose another product to change finish.|Produkty IKEA zachowują katalogowe wykończenie. Aby je zmienić, wybierz inny produkt.
Dimensions cannot be smaller than the original catalogue size.|Wymiary nie mogą być mniejsze od rozmiaru katalogowego.
Keep the whole item inside this floor and clear of stair openings. Try a smaller item or another position.|Cały obiekt musi mieścić się na podłodze i omijać otwory schodowe. Wybierz mniejszy obiekt lub inne miejsce.
Unlock this object before editing it.|Odblokuj obiekt przed edycją.
This item belongs to another floor.|Obiekt należy do innej kondygnacji.
Unlock this object before deleting it.|Odblokuj obiekt przed usunięciem.
Furniture not found on this floor.|Nie znaleziono mebla na tej kondygnacji.
This room cannot be edited.|Tego pomieszczenia nie można edytować.
Enter a room name.|Podaj nazwę pomieszczenia.
Room dimensions must be between 1 and 50 m.|Wymiary pomieszczenia muszą wynosić od 1 do 50 m.
Exterior outline is fixed. Drag an interior partition.|Obrys zewnętrzny jest stały. Przeciągnij ścianę działową.
Unlock this object before moving it.|Odblokuj obiekt przed przesunięciem.
This position is not valid.|Nie można umieścić obiektu w tym miejscu.
Blocks a door swing.|Blokuje otwieranie drzwi.
Overlaps a wall.|Nachodzi na ścianę.
Choose a height variant of this furniture configuration.|Wybierz wariant wysokości tego mebla.
This product is not in the furniture library.|Tego produktu nie ma w katalogu mebli.`.split('\n').map(line => line.split('|')))

export function interiorMessage(text: string) {
  const message = text.replace(/^Error: /, '')
  if (errors[message]) return errors[message]
  if (message === 'This dimension has no single movable interior side. Move a connected partition or use plot tools for exterior walls.') return 'Ten wymiar nie ma pojedynczej ruchomej ściany działowej. Zmień ściany osobno na rzucie; ściany zewnętrzne edytuj w widoku działki.'
  if (message === 'Intersects a wall; move the furniture clear of it.') return 'Obiekt przecina ścianę. Odsuń go od niej.'
  const circulation = message.match(/^Less than 30 cm to (.+); check access\.$/)
  if (circulation) return `Odstęp od ${circulation[1]} jest mniejszy niż 30 cm; sprawdź przejście.`
  const assembly = message.match(/^This IKEA configuration needs at least (.+) cm of clear height for upright assembly\.$/)
  if (assembly) return `Montaż pionowy tej konfiguracji IKEA wymaga co najmniej ${assembly[1]} cm wolnej wysokości.`
  if (message.startsWith('This room has several')) return 'Pomieszczenie ma kilka odcinków ścian po tej stronie. Zmień je osobno, wybierając ścianę na rzucie.'
  if (message.startsWith('Overlaps ')) return `Nachodzi na: ${message.slice(9).replace(/\.$/, '')}.`
  return message
}
